export default "{\n    \"searchPlaceholder\": \"Buscar\"\n}\n"